// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__l8yGG","large":"styles_large__31oDf"};